import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {AppNotification} from '../../../../modules/core/notification/domain/notification';
import {NotificationService} from '../../../service/notification.service';

export interface MobileNotificationsDialogData {
  notifications: AppNotification[];
}

@Component({
  selector: 'app-mobile-notifications-dialog',
  templateUrl: './mobile-notifications-dialog.component.html',
  styleUrls: ['./mobile-notifications-dialog.component.scss'],
  standalone: false
})
export class MobileNotificationsDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<MobileNotificationsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MobileNotificationsDialogData,
    private notificationService: NotificationService,
    private router: Router
  ) {
  }

  markAllAsRead(): void {
    this.notificationService.markAllAsRead().then(() => {
      this.data.notifications.forEach(notification => notification.read = true);
    });
  }

  openNotification(notification: AppNotification): void {
    this.markAsRead(notification);
    this.dialogRef.close();

    if (notification.link) {
      this.router.navigateByUrl(notification.link);
      return;
    }

    this.router.navigate(['/notifications'], {fragment: `notification-${notification.id}`});
  }

  openAllNotifications(): void {
    this.dialogRef.close();
    this.router.navigate(['/notifications']);
  }

  close(): void {
    this.dialogRef.close();
  }

  getPreview(notification: AppNotification): string {
    return notification.description
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/<\/p>/gi, '\n')
      .replace(/<[^>]+>/g, '')
      .replace(/&nbsp;/gi, ' ')
      .trim();
  }

  private markAsRead(notification: AppNotification): void {
    if (!notification.read) {
      notification.read = true;
      this.notificationService.markAsRead(notification.id).catch(() => notification.read = false);
    }
  }
}
